const fileExtensionFromUrl = (url: string) => {
  return url.replace(/.+\.com.+\./g, ".");
};
export default fileExtensionFromUrl;
